<template>
    <div class="ts-content is-secondary is-vertically-padded">
        <div class="ts-space"></div>
        <div class="ts-container ts-center">
            <div class="ts-header is-massive is-heavy">Tabs Unloader 2.0</div>
            <div class="ts-text is-secondary">An extension recapture your own memory from browser.</div>
            <div class="ts-space"></div>
            <div class="ts-grid is-relaxed is-2-columns">
                <div class="column">
                    <div class="ts-image is-small">
                        <a href="https://chrome.google.com/webstore/detail/jageegmimlcfoomhknbhbmbjacmglnlb" target="_blank"><img src="../assets/google_badge.png" style="height: 40px; width: auto;"></a>
                    </div>
                </div>
                <div class="column">
                    <div class="ts-image is-small">
                        <a href="https://microsoftedge.microsoft.com/addons/detail/cnefkmeedalkkciknnilnnfjponcbchh" target="_blank"><img src="../assets/microsoft_badge.png" style="height: 40px; width: auto;"></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="ts-space"></div>
    </div>
    <div class="ts-divider"></div>
    <div class="ts-space is-big"></div>
</template>

<script>
export default {
    name: 'HomeHeader',
}
</script>
